// @flow

import ListPage from 'esm-web-pro/containers/pages/ListPage';
import React from 'react';
import {
    defineMessages, FormattedMessage, injectIntl, useIntl,
} from 'react-intl';
import { Route } from 'react-router';
import DateTimeColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/DateTimeColumn';
import JSONCell from 'esm-web-pro/components/tables/JSONCell';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import DownloadIcon from 'esm-web-pro/components/icons/DownloadIcon';

const messages = defineMessages({
    eit: {
        id: 'adminpage-export',
        defaultMessage: 'Export',
    },
});

const Exports = () => {
    const { formatMessage } = useIntl();

    return (
        <Route
            path="/administration/exports/eit"
            render={(props) => (
                <ListPage
                    {...props}
                    resourceName="eitExport"
                    permissions={['audit.view_auditevent', 'audit.delete_auditevent',
                        'audit.change_auditevent', 'audit.add_auditevent']}
                    title={formatMessage(messages.eit)}
                    columns={[
                        {
                            Header: <FormattedMessage
                                id="audit-typename"
                                defaultMessage="Type name"
                            />,
                            accessor: 'type.translations.bg.name',
                            minWidth: 70,
                        },
                        {
                            Header: <FormattedMessage
                                id="audit-eventdate"
                                defaultMessage="Event date"
                            />,
                            accessor: 'event_date',
                            minWidth: 30,
                            Cell: DateTimeColumn,
                        },
                        {
                            Header: <FormattedMessage
                                id="audit-createdby"
                                defaultMessage="User"
                            />,
                            accessor: 'created_by',
                            minWidth: 30,
                        },
                        {
                            Header: (
                                <FormattedMessage
                                    id="audit-data"
                                    defaultMessage="Data"
                                />
                            ),
                            accessor: 'data',
                            minWidth: 30,
                            Cell: JSONCell,
                        },
                        {
                            Header: <FormattedMessage id="action-action" defaultMessage="Actions" />,
                            actions: [{
                                label: <FormattedMessage id="edit-action" defaultMessage="Download" />,
                                to: '{file}',
                                type: 'link',
                                icon: <DownloadIcon />,
                                routed: false,
                            }],
                            Cell: ActionsColumn,
                            styles: {
                                justify: 'start',
                            },
                            minWidth: 30,
                        },
                    ]}
                />
            )}
        />
    );
};

export default injectIntl(Exports);
